import type {
  IPages,
  IRolePermission,
  IRolePermissionPayload,
  IUserManagementProfile,
  IUserPermissionPayload,
  IUserProfile
} from '@/interfaces/agency/settings/user-management/users';
import axios from '@axios';

export default {
  async fetchUsers(query: object) {
    const params = new URLSearchParams();

    Object.entries(query).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => params.append(key, String(v)));
      } else if (value !== null && value !== undefined) {
        params.append(key, String(value));
      }
    });

    const url = `/profiles?${params.toString()}`;

    return await axios.get(url);
  },

  async fetchUserById(id: number) {
    return await axios.get<IUserProfile>(`/profiles/${id}`);
  },

  async addUser(payload: IUserManagementProfile) {
    return await axios.post('/profiles', payload);
  },

  async updateUser(profileId: number, payload: IUserManagementProfile) {
    return await axios.patch(`/profiles/${profileId}`, payload);
  },

  async updateUserStatus() {
    return await axios.patch('/profiles/bulk/status');
  },

  async removeUser(profileId: number) {
    return await axios.delete(`/profiles/${profileId}`);
  },

  async fetchPagePermission(hideLoader = false) {
    return await axios.get<Array<IPages>>('/permissions/page-permissions', {
      headers: hideLoader ? { 'x-hide-loader': true } : {}
    });
  },

  async fetchRolesPermissions(hideLoader = false) {
    return await axios.get<Array<IRolePermission>>('role-permissions', {
      headers: hideLoader ? { 'x-hide-loader': true } : {}
    });
  },

  async addRolesPermissions(payload: IRolePermissionPayload) {
    return await axios.post('/role-permissions', payload);
  },

  async editRolesPermissions(payload: IRolePermissionPayload) {
    return await axios.patch('/role-permissions', payload);
  },

  async fetchRolesPermissionsById(roleId: number, hideLoader = false) {
    return await axios.get<Array<IPages>>(`/role-permissions/permissions/${roleId}`, {
      headers: hideLoader ? { 'x-hide-loader': true } : {}
    });
  },

  async addUsersPermissions(payload: IUserPermissionPayload) {
    return await axios.post('/user-permissions', payload);
  },

  async editUsersPermissions(payload: IUserPermissionPayload) {
    return await axios.patch('/user-permissions', payload);
  },

  async fetchUsersPermissionsById(profileId: number) {
    return await axios.get<Array<IPages>>(`/user-permissions/${profileId}`);
  },

  async changeUserPassword(profileId: number, payload: { newPassword: string; confirmPassword: string }) {
    return await axios.post(`/profiles/${profileId}/change-password`, payload);
  },

  async rolesAreaRestricted(roleId: number, payload: { isAreaRestricted: boolean }) {
    return await axios.patch(`/roles/${roleId}/area-restriction`, payload);
  }
};
